import { useEffect, useRef } from 'react';

type Props = {
  show: boolean;
  onHide: () => void;
};

export const useClickOutside = ({ show, onHide }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!show) return () => {};
    const onClick = (ev: MouseEvent) => {
      if (ev.target && ref.current) {
        const isContains =
          ref.current === ev.target ||
          (ev.target instanceof Node && ref.current.contains(ev.target));

        if (!isContains) {
          onHide();
        }
      }
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [show]);

  return { ref };
};
